import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreLayoutComponent} from './core-layout/core-layout.component';
import { CoreRoutingModule } from './core-routing.module';
import { RouterModule } from '@angular/router';
import { AuthModule } from '../auth/auth.module';
import { SharedModule } from '../shared/shared.module';
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ApiInterceptor } from '../shared/api.interceptor';

@NgModule({
  declarations: [
    CoreLayoutComponent
  ],
  imports: [
    CommonModule,
    SharedModule.forRoot(),
    RouterModule,
    AuthModule,
    CoreRoutingModule
  ],
  exports: [
    CoreLayoutComponent
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true}
  ]
})
export class CoreModule { }
